import { BaseError } from './BaseError';

/**
 * 多重認証リクエスト例外
 */
export class TooManyAuthRequestError extends BaseError {
}